import { render, staticRenderFns } from "./TexPassportAddEdit.vue?vue&type=template&id=ac1c1b9a&scoped=true&"
import script from "./TexPassportAddEdit.vue?vue&type=script&lang=js&"
export * from "./TexPassportAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1c1b9a",
  null
  
)

export default component.exports